import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyIcon, FlagIcon, PeopleIcon, PersonIcon, TargetIcon } from '../icons';
export const challengeCollaborationTypesMap = {
  global: {
    borderColor: '#B38FFF',
    bgColor: '#EAE2FC',
    color: '#743AEF',
    labelKey: 'commons.challenges.competition_types.global_label',
    Icon: PeopleIcon
  },
  individual: {
    borderColor: '#86D1F1',
    bgColor: '#E7F4FA',
    color: '#1589BB',
    labelKey: 'commons.challenges.competition_types.individual_label',
    Icon: PersonIcon
  },
  teams: {
    borderColor: '#F390BF',
    bgColor: '#FAE3EE',
    color: '#DA3A87',
    labelKey: 'commons.challenges.competition_types.teams_label',
    Icon: FlagIcon
  },
  sites: {
    borderColor: '#FFE27D',
    bgColor: '#FFF5D0',
    color: '#BB8A1A',
    labelKey: 'commons.challenges.competition_types.sites_label',
    Icon: CompanyIcon
  },
  local: {
    borderColor: '#FFB48B',
    bgColor: '#FFEEE0',
    color: '#E06621',
    labelKey: 'commons.challenges.competition_types.local_label',
    Icon: TargetIcon
  }
};
export function ChallengeCollabationTypeChip({
  collaborationType,
  variant
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, collaborationType ? /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: collaborationType?.bgColor,
    borderColor: collaborationType?.borderColor,
    borderRadius: variant === 'top-left-corner' ? '16px 0 16px 0' : 1,
    color: collaborationType?.color,
    display: "flex",
    gap: 1,
    paddingX: 1,
    paddingY: 0.5,
    sx: {
      borderStyle: 'solid',
      borderWidth: variant === 'top-left-corner' ? '0 1px 1px 0' : 1
    }
  }, /*#__PURE__*/React.createElement(collaborationType.Icon, {
    color: "inherit",
    fontWeight: 600,
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "inherit",
    fontWeight: 600,
    lineHeight: 1,
    variant: "body2"
  }, t(collaborationType.labelKey))) : collaborationType === undefined && /*#__PURE__*/React.createElement(_Skeleton, {
    height: 26,
    variant: "rounded",
    width: 200
  }));
}